import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  fonts: {
    heading: `"TiempoHeadline", serif`,
    body: `"Benton Sans", sans-serif`,
  },
  styles: {
    global: {
      body: {
        fontFamily: `"Benton Sans", sans-serif`,
        bg: "gray.900",
        color: "white",
      },
      h1: {
        fontFamily: `"TiempoHeadline", serif`,
      },
      h2: {
        fontFamily: `"TiempoHeadline", serif`,
      },
      h3: {
        fontFamily: `"TiempoHeadline", serif`,
      },
      h4: {
        fontFamily: `"TiempoHeadline", serif`,
      },
      h5: {
        fontFamily: `"TiempoHeadline", serif`,
      },
      h6: {
        fontFamily: `"TiempoHeadline", serif`,
      },
      "html, body": {
        backgroundColor: "gray.900",
        color: "white",
        overflowX: "hidden",
      },
    },
  },
  config: {
    initialColorMode: "dark",
    useSystemColorMode: false,
  },
  semanticTokens: {
    colors: {
      "chakra-body-bg": { _light: "gray.50", _dark: "gray.900" },
      "chakra-body-text": { _light: "gray.800", _dark: "white" },
      "chakra-border-color": { _light: "gray.200", _dark: "gray.700" },
      "chakra-placeholder-color": { _light: "gray.500", _dark: "gray.400" },
    },
  },
  colors: {
    brand: {
      50: "#f0fff4",
      100: "#c6f6d5",
      200: "#9ae6b4",
      300: "#68d391",
      400: "#48bb78",
      500: "#38a169",
      600: "#2f855a",
      700: "#276749",
      800: "#22543d",
      900: "#1C4532",
    },
    // Ensure consistent button colors
    blue: {
      50: "#ebf8ff",
      100: "#bee3f8",
      200: "#90cdf4",
      300: "#63b3ed",
      400: "#4299e1",
      500: "#3182ce",
      600: "#2b6cb0",
      700: "#2c5282",
      800: "#2a4365",
      900: "#1A365D",
    },
    green: {
      50: "#f0fff4",
      100: "#c6f6d5",
      200: "#9ae6b4",
      300: "#68d391",
      400: "#48bb78",
      500: "#38a169",
      600: "#2f855a",
      700: "#276749",
      800: "#22543d",
      900: "#1C4532",
    },
    teal: {
      50: "#E6FFFA",
      100: "#B2F5EA",
      200: "#81E6D9",
      300: "#4FD1C5",
      400: "#38B2AC",
      500: "#319795",
      600: "#2C7A7B",
      700: "#285E61",
      800: "#234E52",
      900: "#1D4044",
    },
  },
});

export default theme;
